import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var sides_all_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "m7.5 6h9v-1.5h-9zm0 13.5h9v-1.5h-9zm-3-3h1.5v-9h-1.5zm13.5-9v9h1.5v-9z" }) });
export {
  sides_all_default as default
};
//# sourceMappingURL=sides-all.js.map
